import { Skeleton } from '@mantine/core';
import { IconAt } from '@tabler/icons';
import validator from 'validator';
import BookitupTextInput from '../../../Atoms/inputs/BookitupTextInput';
import { useEmailAccountingConfig } from '../../../Service/hooks/useEmailAccountingConfig';
import PanePaper from '../../../Molecules/PanePaper';

const AccountingEmailPane = () => {
  const { loading, config, email, update } = useEmailAccountingConfig();

  return (
    <PanePaper title="Rechnung per E-Mail importieren">
      {loading && <Skeleton height={40} width={600} />}
      {config && (
        <BookitupTextInput
          icon={<IconAt size={20} />}
          placeholder="address@accounting.de"
          label="E-Mail"
          defaultValue={email ?? undefined}
          type="email"
          onBlurSave={update}
          validate={validator.isEmail}
          errorMessage="Die E-Mail-Adresse ist ungültig."
          sx={{ maxWidth: 600 }}
        />
      )}
    </PanePaper>
  );
};

export default AccountingEmailPane;
